import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import { useInterfaceStore } from './stores/useInterfaceStore';

// Componente de erro para capturar erros nas rotas
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Atualiza o estado para que o próximo render mostre a UI alternativa.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Erro capturado pelo ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px' }}>
          <h2>Unexpected Application Error!</h2>
          <p>Um erro ocorreu na aplicação. Por favor, recarregue a página.</p>
          <button onClick={() => this.setState({ hasError: false })}>Tentar novamente</button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  const theme = useInterfaceStore((state) => state.theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
  }, [theme]);

  return (
    <ErrorBoundary>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </ErrorBoundary>
  );
}

export default App;
